import { AuthProvidersTypes } from '@app/shared/models/AuthProviders';
import { ADD_FILE_OPTION_NAME } from './app.enum';
import { LOCAL_IMAGES } from './img-constants';

export class StringConstants {
  public readonly ADD_FILE = 'ADD_FILE';
  public readonly LAGUAGES_CODE = [
    'ar',
    'cy',
    'de',
    'el',
    'en',
    'es',
    'fil',
    'fr',
    'ga',
    'he',
    'hi',
    'it',
    'ja',
    'ko',
    'nl',
    'pl',
    'pt',
    'ru',
    'sv',
    'th',
    'uk',
    'zh-hk',
    'zh',
  ];
  public readonly LAGUAGES_CODE_NAMES = {
    ar: { title: 'العربية', subTitle: 'Arabic' },
    cy: { title: 'Cymraeg', subTitle: 'Welsh' },
    de: { title: 'Deutsch', subTitle: 'German' },
    el: { title: 'Ελληνικά', subTitle: 'Greek' },
    en: { title: 'English', subTitle: 'English' },
    es: { title: 'Española', subTitle: 'Spanish' },
    fil: { title: 'Filipino', subTitle: 'Filipino' },
    fr: { title: 'Français', subTitle: 'French' },
    ga: { title: 'Gaeilge', subTitle: 'Irish' },
    he: { title: 'עִברִית', subTitle: 'Hebrew' },
    hi: { title: 'हिन्दी', subTitle: 'Hindi' },
    it: { title: 'Italiana', subTitle: 'Italian' },
    ja: { title: '日本', subTitle: 'Japanese' },
    ko: { title: '한국인', subTitle: 'Korean' },
    nl: { title: 'Nederlands', subTitle: 'Dutch' },
    pl: { title: 'Polski', subTitle: 'Polish' },
    pt: { title: 'Português', subTitle: 'Portuguese' },
    ru: { title: 'Русский', subTitle: 'Russian' },
    sv: { title: 'svenska', subTitle: 'Swedish' },
    th: { title: 'ไทย', subTitle: 'Thai' },
    uk: { title: 'українська', subTitle: 'Ukrainian' },
    'zh-hk': { title: '中國傳統的）', subTitle: 'Chinese (Traditional)' },
    zh: { title: '简体中文）', subTitle: 'Chinese (Simplified)' },
  };
  public readonly SYSTEM_LANG = 'System Language';
  public readonly AUTH_PROVIDERS_WITH_BARCODE_TEXT = [
    AuthProvidersTypes.sirsi.toLowerCase(),
    AuthProvidersTypes.polaris.toLowerCase(),
    AuthProvidersTypes.innovative.toLowerCase(),
    AuthProvidersTypes.sirsiWeb.toLowerCase(),
    AuthProvidersTypes.polarisWeb.toLowerCase(),
  ];
  public readonly DEFAULT_SUPPORTED_LANG = {
    _id: '64510781bf538fcb3741d1f4',
    language: 'English',
    locale: 'en',
    flagLang: 'us',
    currency: 'USD',
    date: 'en-US',
    currencySymbol: '$',
  };
}

export const MAP_DISTANCE_MILES = [
  { label: '1', value: 1 },
  { label: '5', value: 5 },
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];
export const CLOUD_ADD_FILE_OPTIONS = [
  {
    id: 5,
    label: 'Drop Box',
    name: ADD_FILE_OPTION_NAME.Dropbox, //"Dropbox",
    icon: LOCAL_IMAGES.dropboxWhite, // './assets/images/dropbox_white.png',
    size: 4,
  },
  {
    id: 6,
    label: 'Box',
    name: ADD_FILE_OPTION_NAME.Box, // "Box",
    icon: LOCAL_IMAGES.boxWhite, // './assets/images/box_white.png',
    size: 4,
  },
  {
    id: 7,
    label: 'Google Drive',
    name: ADD_FILE_OPTION_NAME.Google_Drive, //"Google Drive",
    icon: LOCAL_IMAGES.googleDriveWhite, // './assets/images/google_drive_white.png',
    size: 4,
  },
  {
    id: 8,
    label: 'OneDrive',
    name: ADD_FILE_OPTION_NAME.OneDrive, //"OneDrive",
    icon: LOCAL_IMAGES.oneDriveWhite, // './assets/images/one_drive_white.png',
    size: 4,
  },
  {
    id: 9,
    label: 'Office 365',
    name: ADD_FILE_OPTION_NAME.Office_365, //"Office 365",
    icon: LOCAL_IMAGES.microsoftOfficeWhite, // './assets/images/microsoft_office_white.png',
    size: 4,
  },
];

export const ADD_FILE_OPTIONS = [
  {
    id: 1,
    label: 'EMAIL',
    name: ADD_FILE_OPTION_NAME.Email, //"Email",
    icon: LOCAL_IMAGES.emailWhite, // './assets/images/email_white.png',
    size: 4,
  },
  {
    id: 2,
    label: 'PICTURES',
    name: ADD_FILE_OPTION_NAME.Pictures, //"Pictures",
    icon: LOCAL_IMAGES.picturesWhite, // './assets/images/pictures_white.png',
    size: 4,
  },
  {
    id: 3,
    label: 'FILES',
    name: ADD_FILE_OPTION_NAME.Files, //"Files",
    icon: LOCAL_IMAGES.browserWhite, // './assets/images/browser_white.png',
    size: 4,
  },
  // {
  //   id: 4,
  //   name: ADD_FILE_OPTION_NAME.Web, //"Web",
  //   icon: "./assets/images/web_white.png",
  // },
  ...CLOUD_ADD_FILE_OPTIONS,
];


export const CLOUD_ACCOUNTS = [
  {
    label: 'GoogleDrive',
    title: ADD_FILE_OPTION_NAME.Google_Drive, //"Google Drive",
    url: "/auth/login",
    ionicIcon: "cloud-outline",
    isEnabled: false,
    isVisible: true
  },
  {
    label: 'Box',
    title: ADD_FILE_OPTION_NAME.Box, // "Box",
    url: "/auth/login",
    ionicIcon: "cloud-outline",
    isEnabled: false,
    isVisible: true
  },
  {
    label: 'OneDrive',
    title: ADD_FILE_OPTION_NAME.One_Drive, // "One Drive",
    url: "/auth/login",
    ionicIcon: "cloud-outline",
    isEnabled: false,
    isVisible: true
  },
  {
    label: 'Drop Box',
    title: ADD_FILE_OPTION_NAME.Drop_Box, // "Drop Box",
    url: "/getting-started",
    ionicIcon: "cloud-outline",
    isEnabled: false,
    isVisible: true
  },
  {
    label: 'Office 365',
    title: ADD_FILE_OPTION_NAME.Office_365, // "Office 365",
    url: "/getting-started",
    ionicIcon: "cloud-outline",
    isEnabled: false,
    isVisible: true
  },
];
export const EXTENSION_TO_MIME = {
  pdf: 'application/pdf',
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  tif: 'image/tif',
  tiff: 'image/tiff',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pub: 'application/x-mspublisher',
  rtf: 'application/rtf',
  htm: 'text/html',
  html: 'text/html',
  txt: 'text/plain',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ppt: 'application/vnd.ms-powerpoint',
  odt: 'application/vnd.oasis.opendocument.text',
  xps: 'application/oxps',
  oxps: 'application/oxps',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  odp: 'application/vnd.oasis.opendocument.presentation',
  heic: 'image/heic',
  svg: 'image/svg+xml',
  epub: 'application/epub+zip',
  vsd: 'application/vnd.visio',
  wmf: 'application/x-msmetafile',
  webp: 'image/webp',
};
